import React, { useEffect, useState } from 'react';
import QnaFilter from './QnaFilter';
import { Pagination } from 'antd';
import { useParams } from 'react-router-dom';
import { QnaTicket } from 'interface/Qna';
import { useMasterUserSelector } from '../../../../redux/selector';
import {
  convertDateTime,
  fetchApiDelete,
  fetchApiGet,
  fetchApiPut,
  getApiFilter,
  getStatus,
  getStatusRate,
  getUrlPage,
} from 'utils/helper';
import { API_GET_QA_TICKET_DETAIL, API_GET_QNA_UPDATE_TICKET, NUM_TICKET_ON_PAGE } from 'config/data';
import { getStatusClass, MEDIA_TYPE, QA_TICKET_STATUS, ROLE_NAME } from 'utils/data';
import { AppState } from 'interface/stateApp';
import { Ticket } from 'model/QnA';
import QaReportModal from 'component/common/QaReport';
import ColaboratorListModal from 'component/common/colaboratorList';
import toast, { NotifyType } from 'utils/toast';
import QuestionAndAnswerTicketModal from '../QuestionAndAnswerTicket/QuestionAndAnswerTicketModal';

interface QnaTicketTableProps {
  hiddenFilter?: boolean;
  subjectIdFilter?: string
}


export const QnaTicketTable = ( {hiddenFilter,subjectIdFilter}: QnaTicketTableProps) => {
  const { subjectId } = useParams();
  const [tickets, setTickets] = useState<QnaTicket[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ticketSize, setTicketSize] = useState(0);
  const [ticketSelect, setTicketSelect] = useState<Ticket | null>(null);
  const user = useMasterUserSelector();
  const [apiFilter, setApiFilter] = useState('');
  const [ticketModalKey, setTicketModalKey] = useState<any>();
  const [stateApp, setStateApp] = useState<AppState>({
    showQnTicketForm: false,
    showReportForm: false,
  });

  const handleUpdateData = (data: any) => {
    const limitedData = data['data'].slice(0, NUM_TICKET_ON_PAGE); // Chỉ lấy 8 bản ghi đầu tiên
    setTicketSize(data['pageSize']);
    setTickets(limitedData);
  };

  const getData = async (page?: number) => {
    if (subjectId === undefined && !subjectIdFilter) return;
    let subjectIdSend = subjectIdFilter ? subjectIdFilter : subjectId;
    let pageSend = page ? page : currentPage;
    let api_filter_ticket = getApiFilter(subjectIdSend as string);
    if (api_filter_ticket === '') return;
    let url = getUrlPage(api_filter_ticket, pageSend, NUM_TICKET_ON_PAGE);
    const data: any = await fetchApiGet(url);
    if (data !== null) {
      const limitedData = data['content'].slice(0, NUM_TICKET_ON_PAGE); // Chỉ lấy 8 bản ghi đầu tiên
      setTicketSize(data['totalElements']);
      setTickets(limitedData);
    } else {
      toast(NotifyType.ERROR, 'Có lỗi xảy ra!');
    }
  };

  const handleUpdateAPiFilter = (api: any) => {
    setApiFilter(api);
  };
  const updateTicket = async (ticket: any) => {
    if (ticket?.receive === true) return;
    ticket = { ...ticket, receive: true, status: QA_TICKET_STATUS.PROCESS };
    const response = await fetchApiPut(`${API_GET_QNA_UPDATE_TICKET}${ticket?.id}`, ticket, MEDIA_TYPE.JSON);
    if (response !== null) {
      toast(NotifyType.SUCCESS, 'Nhận phiếu thành công!');
      const updatedTickets = tickets.map((item) => {
        if (item.id === ticket.id) {
          return ticket;
        }
        return item;
      });
      setTickets(updatedTickets);
    } else {
      toast(NotifyType.ERROR, 'Có lỗi xảy ra!');
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getData(page);
  };

  const handleSelectTicket = (ticket: QnaTicket) => {
    if ((ticket?.colaboratorId === user?.id && ticket?.receive === true) || user?.role === ROLE_NAME.ROLE_ADMIN) {
      setTicketSelect(ticket);
      setTicketModalKey(Date.now());
      setStateApp({ ...stateApp, showQnTicketForm: true });
    } else {
      toast(NotifyType.WARNING, 'Vui lòng tiếp nhận phiếu!');
    }
  };
  const handleUpdateCurrentTicket = (ticket: any) => {
    console.log(ticket);
    setTickets((prevTickets) => prevTickets.map((t) => (t.id === ticket.id ? { ...t, ...ticket } : t)));
  };

  const handleShowReport = (ticket: any) => {
    if (user?.role !== ROLE_NAME.ROLE_ADMIN) return;
    if (ticket?.status === QA_TICKET_STATUS.REPORT) {
      setStateApp({ ...stateApp, showReportForm: true });
      setTicketSelect(ticket);
    }
  };

  const handleDelete = async (ticketId: string) => {
    const response = await fetchApiDelete(`${API_GET_QA_TICKET_DETAIL}${ticketId}`);
    if (response !== null) {
      setTickets((prevTickets) => prevTickets.filter((ticket) => ticket.id !== ticketId));
      toast(NotifyType.SUCCESS, 'Xóa phiếu hỏi thành công!');
    } else {
      toast(NotifyType.WARNING, 'Không thể xóa phiếu hỏi này!');
    }
  };

  const handleShowColaboratorList = (ticket: any) => {
    setTicketSelect(ticket);
    setStateApp({ ...stateApp, showColaboratorListForm: true });
  };
  useEffect(() => {
    setCurrentPage(0);
    getData().then();
  }, [subjectId, user]);

  return (
    <div className="container flex flex-col mx-auto p-4 h-[98%] w-full">
      {
        !hiddenFilter && (
          <QnaFilter onData={handleUpdateData} onFilter={handleUpdateAPiFilter}></QnaFilter>
        )
      }

      <QuestionAndAnswerTicketModal
        stateApp={stateApp}
        setStateApp={setStateApp}
        ticket={ticketSelect}
        onData={handleUpdateCurrentTicket}
        modalKey={ticketModalKey}
      />
      <QaReportModal
        stateApp={stateApp}
        setStateApp={setStateApp}
        ticket={ticketSelect}
        onData={handleUpdateCurrentTicket}
      />
      <ColaboratorListModal
        stateApp={stateApp}
        setStateApp={setStateApp}
        ticket={ticketSelect}
        onData={handleUpdateCurrentTicket}
      ></ColaboratorListModal>
      <div className="flex flex-col bg-white h-[100%] p-2 rounded-sm">
        <div className="overflow-x-auto bg-white">
          <table className="min-w-full bg-white border border-gray-300">
            <thead className="bg-[#f2f2f2]">
              <tr>
                <th className="border border-gray-300 text-center py-3 px-4 font-semibold text-sm">Chọn</th>
                <th className="border border-gray-300 text-left py-3 px-4  font-semibold text-sm">Tên phiếu</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Môn</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">
                  Thời gian bắt đầu
                </th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">
                  Thời gian kết thúc
                </th>
                <th className="border border-gray-300 ttext-center py-3 px-4  font-semibold text-sm">Trạng thái</th>
                {user !== null && user?.role === ROLE_NAME.ROLE_ADMIN ? (
                  <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Tên CTV</th>
                ) : null}
                {user !== null && user?.role === ROLE_NAME.ROLE_ADMIN ? (
                  <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Đánh giá</th>
                ) : null}
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Hành động</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {tickets?.map((ticket: any) => (
                <tr key={ticket.id}>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    <input type="checkbox" />
                  </td>
                  <td
                    className="border border-gray-300 text-left py-3 px-4 break-words text-[#1179be] underline cursor-pointer"
                    onClick={() => handleSelectTicket(ticket)}
                  >
                    {ticket.ticketName}
                  </td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">{ticket.subject?.name}</td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    {convertDateTime(ticket.startTime)}
                  </td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    {ticket?.endTime !== null ? convertDateTime(ticket.endTime) : null}
                  </td>
                  <td
                    className={`border border-gray-300 text-center py-3 px-4 break-words ${getStatusClass(ticket.status)}`}
                    onClick={() => handleShowReport(ticket)}
                  >
                    {getStatus(ticket.status)}
                  </td>
                  {user !== null && user?.role === ROLE_NAME.ROLE_ADMIN ? (
                    <td className="border border-gray-300 text-center py-3 px-4 break-words">
                      {ticket.colaboratorId !== null && ticket?.receive ? 'Nguyễn Văn A' : ''}
                    </td>
                  ) : null}
                  {user !== null && user?.role === ROLE_NAME.ROLE_ADMIN ? (
                    <td className="border border-gray-300 text-center py-3 px-4 break-words">
                      {getStatusRate(ticket)}
                    </td>
                  ) : null}
                  {user !== null && user?.role === ROLE_NAME.ROLE_ADMIN ? (
                    <td className="flex items-center justify-center border border-gray-300 text-center py-3 px-4 border-b-0">
                      {ticket?.colaboratorId === null || ticket?.colaboratorId === '' ? (
                        <button
                          className="flex-1 bg-blue-500 hover:bg-blue-700 text-white py-1 px-3 rounded-lg mx-1"
                          onClick={() => handleShowColaboratorList(ticket)}
                        >
                          Giao
                        </button>
                      ) : (
                        <div className="flex-1 text-white py-1 px-3 rounded-lg mx-1"></div>
                      )}
                      <button
                        className="flex-1 bg-red-500 hover:bg-red-700 text-white py-1 px-3 rounded-lg mx-1"
                        onClick={() => handleDelete(ticket?.id)}
                      >
                        Xóa
                      </button>
                    </td>
                  ) : (
                    <td className="border border-gray-300 text-center py-3 px-4">
                      <button
                        className={`${ticket?.receive ? 'bg-green-500 hover:bg-green-700' : 'bg-blue-500 hover:bg-blue-700'
                          } text-white py-1 px-3 rounded-lg mx-auto`}
                        onClick={() => updateTicket(ticket)}
                      >
                        {ticket?.receive ? 'Đã tiếp nhận' : 'Nhận phiếu'}
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex-grow"></div>
        <div className="flex justify-end mt-3 mb-2">
          <Pagination
            defaultCurrent={currentPage}
            total={ticketSize}
            pageSize={NUM_TICKET_ON_PAGE}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};
